import {Box, Grid, Stack, Typography} from "@mui/material";
import MhdIconMenu from "../../atomicComponents/MhdIconMenu";
import {useCallback, useEffect, useState} from "react";
import MhdDatetime from "../../atomicComponents/MhdDatetime";
import MhdInput from "../../atomicComponents/MhdInput";
import {
  corModelFilters,
  runTypeFilters,
  solutionChoices,
  timeOfInterestEventsFilters,
  variableChoices
} from "../../../utils/choices";
import MhdMultiSelect from "../../atomicComponents/MhdMultiSelect";
import Button from "@mui/material/Button";
import {getCorRuns, getCrToDt, getDtToCr, getScTranges} from "../../../utils/api";
import dayjs from "dayjs";
import {useTheme} from "@mui/material/styles";

const DatabaseFilters = ({setCorData}) => {
  const theme = useTheme();
  const [filterParams, setFilterParams] = useState({
    time_of_interest: null,
    trange_lower_bound: null,
    trange_upper_bound: null,
    simulation_model: [],
    simulation_type: [],
    radial_domain: [],
    variable_set: []
  })
  const [trangeLowerBoundEventsFilters, setTrangeLowerBoundEventsFilters] = useState([])
  const [trangeUpperBoundEventsFilters, setTrangeUpperBoundEventsFilters] = useState([])
  const [matchingTOI, setMatchingTOI] = useState('')
  const [matchingT0, setMatchingT0] = useState('')
  const [matchingT1, setMatchingT1] = useState('')
  const [cr0, setCr0] = useState(null)
  const [cr1, setCr1] = useState(null)
  const [cri, setCri] = useState(null)

  useEffect(() => {
    getScTranges()
      .then(response => {
        setTrangeLowerBoundEventsFilters(response.data.lower_boundaries)
        setTrangeUpperBoundEventsFilters(response.data.upper_boundaries)
      })
      .catch(error => {

      });
  }, [])

  useEffect(() => {
    if (filterParams.time_of_interest !== null) {
      const formattedTime = dayjs(filterParams.time_of_interest).format('YYYY-MM-DD HH:mm:ss');

      const temp = timeOfInterestEventsFilters.find(
        (item) => item.value === formattedTime
      );
      if (temp !== undefined) {
        setMatchingTOI(temp.label)
      } else {
        setMatchingTOI('')
      }
    } else {
      setMatchingTOI('')
    }

  }, [filterParams.time_of_interest]);

  useEffect(() => {
    if (filterParams.trange_lower_bound !== null) {
      const formattedTime = dayjs(filterParams.trange_lower_bound).format('YYYY-MM-DD HH:mm:ss');

      const temp = trangeLowerBoundEventsFilters.find(
        (item) => item.value === formattedTime
      );
      if (temp !== undefined) {
        setMatchingT0(`${temp.label} Lower Data Bound`)
      } else {
        setMatchingT0('')
      }
    } else {
      setMatchingT0('')
    }

}, [filterParams.trange_lower_bound]);

  useEffect(() => {
    if (filterParams.trange_upper_bound !== null) {
      const formattedTime = dayjs(filterParams.trange_upper_bound).format('YYYY-MM-DD HH:mm:ss');

      const temp = trangeUpperBoundEventsFilters.find(
        (item) => item.value === formattedTime
      );
      if (temp !== undefined) {
        setMatchingT1(`${temp.label} Upper Data Bound`)
      } else {
        setMatchingT1('')
      }
    } else {
      setMatchingT1('')
    }

  }, [filterParams.trange_upper_bound]);

  useEffect(() => {
    const corFilterParams = {
      time_of_interest: filterParams.time_of_interest && dayjs(filterParams.time_of_interest).isValid()
        ? dayjs(filterParams.time_of_interest).format('YYYY-MM-DD HH:mm:ss')
        : '',
      trange_lower_bound: filterParams.trange_lower_bound && dayjs(filterParams.trange_lower_bound).isValid()
        ? dayjs(filterParams.trange_lower_bound).format('YYYY-MM-DD HH:mm:ss')
        : '',
      trange_upper_bound: filterParams.trange_upper_bound && dayjs(filterParams.trange_upper_bound).isValid()
        ? dayjs(filterParams.trange_upper_bound).format('YYYY-MM-DD HH:mm:ss')
        : '',
      simulation_model: filterParams.simulation_model,
      simulation_type: filterParams.simulation_type,
      radial_domain: filterParams.radial_domain,
      variable_set: filterParams.variable_set
    }
    getCorRuns(corFilterParams)
      .then(response => {
        setCorData(response.data)
      })
      .catch(error => {

      });
  }, [filterParams]);

  const handleFilterChange = (fieldName, fieldValue) => {
    setFilterParams(prevData => ({
      ...prevData,
      [fieldName]: fieldValue
    }));
  };

  const handleClearFilters = () => {
    setFilterParams({
      time_of_interest: null,
      trange_lower_bound: null,
      trange_upper_bound: null,
      simulation_model: [],
      simulation_type: [],
      radial_domain: [],
      variable_set: []
    })
    setCr0(null)
    setCr1(null)
    setCri(null)
  }

  const dtToCR = (k, v, crSetter) => {
    handleFilterChange(k, v)
    if (v) {
      getDtToCr({dt: v})
        .then(response => {
          crSetter(response.data.toFixed(2))
        })
    } else {
      crSetter('')
    }
  }

  const crToDT = (k, v, crSetter) => {
    crSetter(v)
    if (v) {
      getCrToDt({cr: v})
        .then(response => {
          response.data && handleFilterChange(k, response.data)
        })
    } else {
      handleFilterChange(k, null)
    }
  }
  return (
    <Stack direction={{xs: 'column', sm: 'row'}} width={'100%'} spacing={1}>
      <Box
        width={{xs: '100%', sm: '50%'}}
        sx={{
          // border: '1px solid #c5c5c5',
          p: 2,
          borderRadius: '8px',
          bgcolor: theme.palette.base.rothko5,
          boxShadow: `
            inset 6px 6px 8px rgba(0, 0, 0, 0.3),
            inset -6px -6px 8px rgba(255, 255, 255, 0.5)
          `,
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={1} mt={'12px'} mb={0}>
            <Box
              display='flex'
              alignItems='start'
              justifyContent='center'
              height='100%'
            >
              <MhdIconMenu
                label={'Spacecraft Time Ranges'}
                choices={trangeLowerBoundEventsFilters}
                onChange={useCallback((v) => dtToCR('trange_lower_bound', v, setCr0), [])}
              />
            </Box>
          </Grid>
          <Grid item xs={7}>
            <MhdDatetime
              label={'Time Range (Start)'}
              value={filterParams.trange_lower_bound}
              onChange={useCallback((v) => dtToCR('trange_lower_bound', v, setCr0), [])}
            />
            <Typography
              variant={'caption'}
              color={'primary'}
              ml={'2px'}
              fontStyle={'italic'}
            >
              {matchingT0}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <MhdInput
              label={'CR Range (Start)'}
              value={cr0}
              onChange={useCallback((v) => crToDT('trange_lower_bound', v, setCr0), [])}
              units={'CR'}
              clear={true}
            />
          </Grid>
          <Grid item xs={1} mt={'12px'} mb={0}>
            <Box
              display='flex'
              alignItems='start'
              justifyContent='center'
              height='100%'
            >
             <MhdIconMenu
                label={'Spacecraft Time Ranges'}
                choices={trangeUpperBoundEventsFilters}
                onChange={useCallback((v) => dtToCR('trange_upper_bound', v, setCr1), [])}
              />
            </Box>
          </Grid>
          <Grid item xs={7}>
            <MhdDatetime
              label={'Time Range (End)'}
              value={filterParams.trange_upper_bound}
              onChange={useCallback((v) => dtToCR('trange_upper_bound', v, setCr1), [])}
            />
            <Typography
              variant={'caption'}
              color={'primary'}
              ml={'2px'}
              fontStyle={'italic'}
            >
              {matchingT1}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <MhdInput
              label={'CR Range (End)'}
              value={cr1}
              onChange={useCallback((v) => crToDT('trange_upper_bound', v, setCr1), [])}
              units={'CR'}
              clear={true}
            />
          </Grid>
          <Grid item xs={1} mt={'12px'} mb={0}>
            <Box
              display='flex'
              alignItems='start'
              justifyContent='center'
              height='100%'
            >
            <MhdIconMenu
              label={'Key Events'}
              choices={timeOfInterestEventsFilters}
              onChange={useCallback((v) => dtToCR('time_of_interest', v, setCri), [])}
            />
            </Box>
          </Grid>
          <Grid item xs={7}>
            <MhdDatetime
              label={'Time Of Interest'}
              value={filterParams.time_of_interest}
              onChange={useCallback((v) => dtToCR('time_of_interest', v, setCri), [])}
            />
            <Typography
              variant={'caption'}
              color={'primary'}
              ml={'2px'}
              fontStyle={'italic'}
            >
              {matchingTOI}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <MhdInput
              label={'CR of Interest'}
              value={cri}
              onChange={useCallback((v) => crToDT('time_of_interest', v, setCri), [])}
              units={'CR'}
              clear={true}
            />
          </Grid>
        </Grid>
      </Box>
      <Box
        width={{xs: '100%', sm: '50%'}}
        sx={{
          p: 2,
          borderRadius: '8px',
          bgcolor: theme.palette.base.rothko5,
          boxShadow: `
            inset 6px 6px 8px rgba(0, 0, 0, 0.3),
            inset -6px -6px 8px rgba(255, 255, 255, 0.5)
          `,
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={6} pb={2}>
            <MhdMultiSelect
              label='Models'
              choices={corModelFilters}
              value={filterParams.simulation_model}
              onChange={useCallback((v) => handleFilterChange('simulation_model', v), [])}
            />
          </Grid>
          <Grid item xs={6} pb={2}>
            <MhdMultiSelect
              label='Types'
              choices={runTypeFilters}
              value={filterParams.simulation_type}
              onChange={useCallback((v) => handleFilterChange('simulation_type', v), [])}
            />
          </Grid>
          <Grid item xs={6} pb={2}>
            <MhdMultiSelect
              label='Domains'
              choices={solutionChoices}
              value={filterParams.radial_domain}
              onChange={useCallback((v) => handleFilterChange('radial_domain', v), [])}
            />
          </Grid>
          <Grid item xs={6} pb={2}>
            <MhdMultiSelect
              label='Variables'
              choices={variableChoices}
              value={filterParams.variable_set}
              onChange={useCallback((v) => handleFilterChange('variable_set', v), [])}
            />
          </Grid>
          <Grid item xs={12} mt={1}>
            <Button
              onClick={handleClearFilters}
              variant={'contained'}
              color={'error'}
              fullWidth={true}
            >
              Clear Filters
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
}

export default DatabaseFilters;